<template>
  <div class="sf-el short-answer-input">
    <div class="sf-short-answer">
      <label class="sf-el__label">
        {{ label }}
        <span v-if="required" class="sf-el__required">*</span>
      </label>
      <p v-if="caption" class="sf-el__caption">{{ caption }}</p>
      <textarea v-model="value" :placeholder="placeholder" rows="4"></textarea>
    </div>
  </div>
</template>

<script>
  import { watch, ref } from 'vue';
  export default {
    name: 'LongAnswerElement',
    props: {
      label: String,
      caption: String,
      placeholder: String,
      name: String,
      modelValue: String,
      required: Boolean,
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
      const value = ref(props.modelValue);
      watch(value, (newValue) => {
        emit('update:modelValue', newValue);
      });
      return {
        value,
      };
    },
  };
</script>

<style scoped lang="scss">
  .sf-short-answer {
  }
</style>
